import { fromJS, List } from 'immutable';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { getCustomWidgetType } from 'reporting-data/report/reportGetters';
import { isQuickFilterEditorSchema } from 'reporting-data/tsTypes/editorTypes';
import { HAS_PROPERTY, IN, NOT_HAS_PROPERTY } from 'reporting-data/constants/operators';
import { BaseQuickFilterEditor } from './BaseQuickFilterEditor';
import { getValueFieldForSchema, isFilterApplied, isSalesQuotaPipelineFilter, SALES_QUOTA_NO_PIPELINE_VALUE } from './quickFilterEditorUtils';
import getConfigDataType from '../common/getConfigDataType';
import { ReportOptionsCategories } from '../../singleReportViewer/fullPage/sidebar/categorized/ReportOptionCategory';
import { jsx as _jsx } from "react/jsx-runtime";
export const isFilterSchemaMatch = (filter, schema, customWidgetType) => {
  if (filter.get('property') !== schema.property) {
    return false;
  }
  if (filter.get('operator') === schema.operator) {
    return true;
  }
  return isSalesQuotaPipelineFilter(schema.property, customWidgetType) && [HAS_PROPERTY, NOT_HAS_PROPERTY].includes(filter.get('operator'));
};
const getNewFilter = (schema, customWidgetType, filterValue) => {
  const {
    property,
    operator
  } = schema;
  const isQuotaPipelineFilter = isSalesQuotaPipelineFilter(property, customWidgetType);
  if (!isFilterApplied(filterValue)) {
    return isQuotaPipelineFilter ? fromJS({
      property,
      operator: HAS_PROPERTY
    }) : null;
  }
  if (isQuotaPipelineFilter && filterValue === SALES_QUOTA_NO_PIPELINE_VALUE) {
    return fromJS({
      property,
      operator: NOT_HAS_PROPERTY
    });
  }
  return fromJS({
    property,
    operator,
    [getValueFieldForSchema(schema)]: filterValue
  });
};
const getUpdatedFilters = (originalFilters, schema, customWidgetType, filterValue) => {
  const propertyFilterAlreadyExistsOnReport = originalFilters.some(filter => isFilterSchemaMatch(filter, schema, customWidgetType));
  const newFilter = getNewFilter(schema, customWidgetType, filterValue);
  if (!propertyFilterAlreadyExistsOnReport) {
    return newFilter ? originalFilters.push(newFilter) : originalFilters;
  }
  return originalFilters.reduce((updatedFilters, filter) => {
    if (isFilterSchemaMatch(filter, schema, customWidgetType)) {
      return newFilter ? updatedFilters.push(newFilter) : updatedFilters;
    }
    return updatedFilters.push(filter);
  }, List());
};
export const strategy = {
  isSupportedForReport: report => isConfigReport(report),
  updateReport: (report, schema, filterValue) => {
    const customWidgetType = getCustomWidgetType(report);
    return report.updateIn(['config', 'filters', 'custom'], List(), customFilters => getUpdatedFilters(customFilters, schema, customWidgetType, filterValue));
  },
  getDataType: getConfigDataType,
  getCurrentValue: (report, schema) => {
    const customFilters = report.getIn(['config', 'filters', 'custom'], List());
    const customWidgetType = getCustomWidgetType(report);
    const match = customFilters.find(filter => isFilterSchemaMatch(filter, schema, customWidgetType));
    if (!match || match.get('operator') === HAS_PROPERTY) {
      return schema.operator === IN ? [] : null;
    }
    if (match.get('operator') === NOT_HAS_PROPERTY) {
      return SALES_QUOTA_NO_PIPELINE_VALUE;
    }
    return match.toJS()[getValueFieldForSchema(schema)];
  }
};
const SingleObjectQuickFilterEditorComponent = props => {
  return /*#__PURE__*/_jsx(BaseQuickFilterEditor, Object.assign({}, props, {
    strategy: strategy,
    schema: props.schema
  }));
};
export const SingleObjectQuickFilterEditor = {
  matchesEditorType: (report, schema) => {
    return isQuickFilterEditorSchema(schema) && strategy.isSupportedForReport(report);
  },
  EditorComponent: SingleObjectQuickFilterEditorComponent,
  category: ReportOptionsCategories.More
};